export default __webpack_public_path__ + "static/media/gmail.cf6e9da6.svg";